<template>
  <el-dialog
    title="添加收藏夹"
    :visible.sync="visible"
    @close="dialogClose"
    width="400px"
    class="changeEditType"
  >
    <el-form :model="dirNameForm" :inline="true" :rules="dirNameRule" ref="dirNameForm">
      <el-form-item prop="dirName" label="收藏夹名称">
        <el-input
          class="dir-name-input"
          style="width: 250px;"
          v-model="dirNameForm.dirName"
          placeholder="请输入收藏夹名称"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="handleAddCollectDir('dirNameForm')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { DOMAIN } from "../utils/api";
import { MSG } from "../utils/utils";
import http from "../utils/http";

export default {
  name: "collectDirDialog",
  data() {
    return {
      interface: {
        addDir: `/questionDir/addDir`
      },
      dirNameForm: {
        dirName: ""
      },
      dirNameRule: {
        dirName: [
          { required: true, message: "请输入收藏文件名称", trigger: "blur" }
        ]
      },
      visible: false
    };
  },
  props: ["dialogShow"],
  watch: {
    dialogShow: {
      handler(val) {
        this.visible = val;
      }
    }
  },
  methods: {
    handleAddCollectDir(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this._addCollectDir(this.dirNameForm.dirName);
        } else {
          return false;
        }
      });
    },
    _addCollectDir(newDirName) {
      http
        .get(this.interface.addDir, {
          dirName: newDirName
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.dirNameForm.dirName = "";
            this.newDirName = "";
            this.dialogClose();
            this.$emit("confirm");
          } else {
            MSG.error(message);
          }
        });
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    }
  }
};
</script>


<style lang="scss" scoped>
.changeEditType {
  strong {
    color: #f0614e;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/collectDirDialog.vue